/**
 * Compares two hierarchical string sections (e.g., "1.2.3" vs "1.10.2") and sorts them accordingly.
 *
 * This function splits each input string by the delimiter '.', creating an array of strings.
 * It then iterates over the parts:
 * - If both parts convert to valid numbers, they are compared numerically.
 * - If one or both parts are not numbers, it falls back to a lexical comparison.
 *
 * The function processes up to the maximum number of parts present in either string.
 *
 * @param a - The first section string to compare.
 * @param b - The second section string to compare.
 * @returns A negative number if `a` should come before `b`, a positive number if `a` should come after `b`, or zero if they are equivalent.
 */
export const tocSort = (a?: string, b?: string): number => {
  const splitA = (a ?? "").split(".");
  const splitB = (b ?? "").split(".");

  for (let i = 0; i < Math.max(splitA.length, splitB.length); i++) {
    const partA = splitA[i] || "";
    const partB = splitB[i] || "";

    const numA = parseInt(partA, 10);
    const numB = parseInt(partB, 10);

    if (!isNaN(numA) && !isNaN(numB)) {
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      if (partA !== partB) {
        return partA.localeCompare(partB);
      }
    }
  }

  return 0;
};
